import DOMPurify from 'dompurify'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import CloseSVG from '../../../assets/svg/close.svg'
import { usePurchaseSingleAirtime } from '../../../redux/airtime/hook'
import Button from '../../button'
import FormInput from '../../form-input'
import FormSelect from '../../form-select'
import Modal from '../modal'
import { employees as employeeAPI } from '../../../api/employees'
import AsyncSelect from 'react-select/async'
import { setAlert } from '../../../redux/components/components-slice'
import { store } from '../../../redux'

function SingleAirtime({ isOpen, closeModal, refresh }) {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    mobile: '',
    description: '',
    amount: '',
  })

  const history = useHistory()

  const { mutateAsync: runAirtime, isLoading: airtimeloading } =
    usePurchaseSingleAirtime()

  const [network, setNetwork] = useState('mtn')

  const networkOptions = [
    { value: 'mtn', label: 'MTN' },
    { value: 'airtel', label: 'Airtel' },
    { value: 'glo', label: 'Glo' },
    { value: 'etisalat', label: 'Etisalat' },
  ]

  function onAirtimePurchaseSuccess(ref) {
    history.push(`/airtime/preview/${ref}`)
  }

  const submitForm = async (e) => {
    e.preventDefault()

    const payload = {
      first_name: DOMPurify.sanitize(formData.first_name),
      last_name: DOMPurify.sanitize(formData.last_name),
      mobile: DOMPurify.sanitize(formData.mobile),
      description: DOMPurify.sanitize(formData.description),
      amount: DOMPurify.sanitize(formData.amount),
      network,
    }

    console.log(payload, 'payload')

    if (
      !payload.first_name ||
      !payload.last_name ||
      !payload.mobile ||
      !payload.description ||
      !payload.amount ||
      !payload.network
    ) {
      store.dispatch(setAlert(true, 'info', 'All fields are required'))
      return
    }

    await runAirtime(payload).then((response) => {
      onAirtimePurchaseSuccess(response.data.ref)
    })
  }

  const [userType, setUserType] = useState('employee')
  const [employee, setEmployee] = useState(null)

  const userOptions = [
    { value: 'employee', label: 'Employee' },
    { value: 'newUser', label: 'New user' },
  ]

  const loadOptions = (inputValue) =>
    new Promise((resolve) => {
      employeeAPI
        .getEmployees({
          limit: 10,
          statusFilter: -1,
          search: inputValue,
          page: 1,
        })
        .then((response) => {
          const data = response.data.map((item) => ({
            label: `${item.first_name} ${item.last_name} ${item.mobile}`,
            value: item.id,
            employeeData: item,
          }))
          resolve(data)
        })
        .catch(() => resolve([]))
    })

  const isDisabled = userType === 'employee' && !employee

  const handleEmployeeSelect = (selected) => {
    setEmployee(selected)

    if (selected) {
      setFormData({
        ...formData,
        first_name: selected.employeeData.first_name,
        last_name: selected.employeeData.last_name,
        mobile: selected.employeeData.mobile,
      })
    }
  }

  const handleUserTypeChange = (selected) => {
    const type = selected.value
    setUserType(type)

    if (type === 'newUser') {
      setEmployee(null)
      setFormData({
        first_name: '',
        last_name: '',
        mobile: '',
        description: '',
        amount: '',
      })
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value,
    })
  }

  return (
    <Modal
      scrollable={true}
      className='!max-w-[700px] !rounded-none'
      isOpen={isOpen}
      centered={true}
    >
      <div className='flex flex-col overflow-auto'>
        <form className='form pb-4' onSubmit={submitForm}>
          <div className='pl-8 pr-8 pt-4'>
            <div className='flex flex-row justify-between items-center'>
              <span className='header-4'>Purchase Airtime</span>
              <div className='cursor-pointer' onClick={closeModal}>
                <img src={CloseSVG} alt='close' />
              </div>
            </div>
          </div>
          <hr className='divider' />

          <div className='flex flex-col mx-8'>
            <div className='flex flex-col mb-3 gap-3'>
              <FormSelect
                value={userOptions.find((opt) => opt.value === userType)}
                options={userOptions}
                onChange={handleUserTypeChange}
                label='Select option'
                extraClass='bg-white'
              />

              {userType === 'employee' && (
                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  className='text-[13px]'
                  placeholder='Type to select employee'
                  loadOptions={loadOptions}
                  onChange={handleEmployeeSelect}
                  classNamePrefix='mySelect'
                />
              )}
            </div>

            <div className='flex flex-row md:flex-col w-full justify-between'>
              <div className='w-full md:w-1/2 pr-2'>
                <FormInput
                  label='First Name'
                  name='first_name'
                  type='text'
                  placeholder='Enter recipient first name'
                  disabled={airtimeloading || isDisabled}
                  value={formData.first_name}
                  onChange={handleInputChange}
                />
              </div>

              <div className='w-full md:w-1/2 pl-2'>
                <FormInput
                  label='Last Name'
                  name='last_name'
                  type='text'
                  placeholder='Enter recipient last name'
                  disabled={airtimeloading || isDisabled}
                  value={formData.last_name}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className='flex flex-row md:flex-col w-full justify-between'>
              <div className='w-full md:w-1/2 pr-2'>
                <FormInput
                  label='Mobile Number'
                  name='mobile'
                  type='text'
                  placeholder='Enter recipient mobile'
                  disabled={airtimeloading || isDisabled}
                  value={formData.mobile}
                  onChange={handleInputChange}
                />
              </div>

              <div className='w-full md:w-1/2 pl-2'>
                <FormSelect
                  value={network}
                  options={networkOptions}
                  onChange={(selected) => setNetwork(selected)}
                  label='Select Network'
                />
              </div>
            </div>

            <div className='flex flex-row md:flex-col w-full justify-between'>
              <div className='w-full md:w-2/3 pr-2'>
                <FormInput
                  label='Description'
                  name='description'
                  type='text'
                  placeholder='Enter description'
                  value={formData.description}
                  onChange={handleInputChange}
                  readOnly={airtimeloading}
                />
              </div>

              <div className='w-full md:w-1/3 pl-2'>
                <FormInput
                  label='Amount'
                  name='amount'
                  type='number'
                  placeholder='Enter amount'
                  value={formData.amount}
                  onChange={handleInputChange}
                  readOnly={airtimeloading}
                />
              </div>
            </div>

            <div className='w-full mt-[20px]'>
              <Button
                text='Run Airtime'
                type='submit'
                disabled={isDisabled}
                loading={airtimeloading}
              />
            </div>
          </div>
        </form>
      </div>
    </Modal>
  )
}

export default SingleAirtime
